exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link{display:inline-block;color:#2f4f4f;padding:.75rem 1rem;border:2px solid #2f4f4f;text-decoration:none;position:relative}.link:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;background-color:#2f4f4f;transition:.25s ease-in-out;transform:scaleY(0);transform-origin:bottom;margin-top:0;z-index:-1}.link:hover{color:#fff}.link:hover:after{transform:scaleY(1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/css/link.css
// module id = ./src/css/link.css
// module chunks = 1 2 4